import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_LOCATION_URL;

//#region Location

// GET request
export function GetLocations(
  clientId: string,
  queryParams?: any
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}clients/${clientId}/locations`,
    "GET",
    queryParams
  );
}

// GET request
export function GetLocationById(locationId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}locations/${locationId}`, "GET");
}

// POST request
export function AddLocation(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}locations`, "POST", body);
}

// PUT request
export function UpdateLocation(
  locationId: string,
  body?: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}locations/${locationId}`, "PUT", body);
}

// DELETE request
export function DeleteLocation(locationId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}locations/${locationId}`, "DELETE");
}

// Restore request
export function RestoreLocation(locationId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}locations/${locationId}`, "PATCH");
}
//#endregion Location
